import { render, staticRenderFns } from "./Consumos.vue?vue&type=template&id=7557e130&scoped=true"
import script from "./Consumos.vue?vue&type=script&lang=js"
export * from "./Consumos.vue?vue&type=script&lang=js"
import style0 from "./Consumos.vue?vue&type=style&index=0&id=7557e130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7557e130",
  null
  
)

export default component.exports